import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import initProjectHeroAnimation from '../util/projectHeroAnimation';

export default {
	init() {
		console.log('single project');

		initProjectHeroAnimation();

		//Wall block
		const wallBlock = document.querySelector('.wall_block');
		if (wallBlock) {
			let wallBlockTl = gsap.timeline({
				scrollTrigger: {
					trigger: wallBlock,
					start: 'top bottom',
					end: 'top 20%',
					scrub: 1,
				},
			});
			wallBlockTl.to('.wall_block img', {
				y: '0%',
				duration: 1,
				ease: 'none',
			});
		}

		let lastSlide;

		// Inizializza Swiper
		new Swiper('.at_project_slider', {
			modules: [Pagination],
			slideToClickedSlide: true,
			pagination: {
				el: '.swiper-pagination',
				type: 'progressbar',
			},
			slidesPerView: 1,
			loop: true,
			on: {
				reachEnd: function () {
					setTimeout(() => {
						lastSlide = true;
					}, 500);
				},
				click: function () {					
					if(this.activeIndex == this.slides.length - 1 && lastSlide){
						lastSlide = false;
						this.slideToLoop(0, 2000)
					}
					
				},
				


			},
		});

		new Swiper('.related_swiper', {
			slidesPerView: 'auto',
		});

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
